import { Command } from '../Command';

/**
 * @param editor Editor
 * @param object THREE.Object3D
 * @param attributeName string
 * @param newValue number, string, boolean or object
 * @constructor
 */
class SetGeometryValueCommand extends Command {
	constructor(editor, object, attributeName, newValue) {
		super(editor);

		this.type = 'SetGeometryValueCommand';
		this.name = `Set Geometry.${attributeName}`;

		this.object = object;
		this.attributeName = attributeName;
		this.oldValue = object !== undefined ? object.geometry[attributeName] : undefined;
		this.newValue = newValue;
	}

	execute() {
		this.object.geometry[this.attributeName] = this.newValue;
		this.editor.signals.objectChanged.dispatch(this.object);
		this.editor.signals.geometryChanged.dispatch();
		this.editor.signals.sceneGraphChanged.dispatch();
	}

	undo() {
		this.object.geometry[this.attributeName] = this.oldValue;
		this.editor.signals.objectChanged.dispatch(this.object);
		this.editor.signals.geometryChanged.dispatch();
		this.editor.signals.sceneGraphChanged.dispatch();
	}

	toSerialized() {
		const output = super.toSerialized(this);

		output.objectUuid = this.object.uuid;
		output.attributeName = this.attributeName;
		output.oldValue = this.oldValue;
		output.newValue = this.newValue;

		return output;
	}

	fromSerialized(json) {
		super.fromSerialized(json);

		this.object = this.editor.objectByUuid(json.objectUuid);
		this.attributeName = json.attributeName;
		this.oldValue = json.oldValue;
		this.newValue = json.newValue;
	}
}

export { SetGeometryValueCommand };
